import { useMutation } from "@tanstack/react-query";
import { updateArticleDetails } from "../api/updateArticleDetails";
import { UpdateArticleDetailsParams } from "../types";
import { invalidateArticleDetailsQuery } from "./useArticleDetailsQuery";

export const useUpdateArticleQuery = () => {
  return useMutation({
    mutationFn: async (params: UpdateArticleDetailsParams) => {
      return await updateArticleDetails(params);
    },
    onSuccess: (_, variables) => {
      invalidateArticleDetailsQuery(variables);
    },
    onError: (e) => console.error(e),
  });
};
